import { React, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUser, logout } from '../API';

import { Avatar } from '@mui/material'
import { deepPurple } from '@mui/material/colors';

import logowhite from "../imgs/logo-busrt-white.png";

import { useTranslation } from "react-i18next";

const Header = () => {

  const [t] = useTranslation('common');

  const [user, setUser] = useState('');

  useEffect(() => {
    getUser()
      .then(response => {
        if (response.user.login !== 'admin') {
          setUser(response.user);
        }
      })
  }, []);

  const handleLogout = async () => {
    let result = await logout();
    sessionStorage.setItem('authed', JSON.stringify(false));
    location.reload();

  }

  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div id="headnav" className="container-fluid">

          <Link className="navbar-brand mb-0 h1 text-white" to="/home">
            <img style={{ width: "120px" }} src={logowhite} />
          </Link>

          {user ? <>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
              <i className="fas fa-bars" style={{ color: '#FFFFFF' }}></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">

              <div className="navbar-nav">

                <div className="dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {t("header.maps.localization")}
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/livemap" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.maps.map")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item " to="/liveroutes" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.maps.linear")}
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {t("header.operations.operation")}
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <li className="dropdown-item">
                      <Link className="nav-item " to="/routeoperation" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.routesreport")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/vehoperation" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.vehiclereport")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/blockoperation" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.blockreport")}
                      </Link>
                    </li>
                    {/* <li className="dropdown-item">
                      <Link className="nav-item" to="/cancelledtrips" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.canceltrips")}
                      </Link>
                    </li> */}
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/compareperiods" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.periods")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/trends" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.trends")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/datatable" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.datatable")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/vehdays" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.operations.vehdays")}
                      </Link>
                    </li>
                  </ul>
                </div>


                <div className="dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {t("header.benchmark.benchmark")}
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/benchmarks" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.benchmark.kpi")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item " to="/courbeservice" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.benchmark.rtservicecurve")}
                      </Link>
                    </li>
                    {/* <li className="dropdown-item">
                      <Link className="nav-item" to="/courbereelplanif" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.benchmark.realplannedcurve")}
                      </Link>
                    </li> */}
                  </ul>
                </div>


                <div className="dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {t("header.otp.ontimeperformance")}
                  </a>
                  <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/ponctualitejour" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.otp.daily")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/ponctualiteroute" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.otp.route")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/ponctualitetrip" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.otp.trip")}
                      </Link>
                    </li>
                    {/* <li className="dropdown-item">
                    <Link className="nav-item" to="/ponctualite_ad_rtl" style={{ textDecoration: 'none', color: '#000000' }}>
                        Cartographie
                    </Link>
                  </li> */}
                  </ul>
                </div>

                <div className="dropdown">
                  <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {t("header.occupancy.occupancy")}
                  </a>
                  <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/chargejour" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.occupancy.daily")}

                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/chargeroute" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.occupancy.route")}
                      </Link>
                    </li>
                    <li className="dropdown-item">
                      <Link className="nav-item" to="/chargetrip" style={{ textDecoration: 'none', color: '#000000' }}>
                        {t("header.occupancy.trip")}
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* <div className="dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Flotte
                </a>
                <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                  <li className="dropdown-item">
                    <Link className="nav-item" to="/vehdays" style={{ textDecoration: 'none', color: '#000000' }}>
                      KM / véhicule / jour
                    </Link>
                  </li>
                </ul>
              </div> */}

                <Link className="nav-item" to="/home">
                  <button onClick={() => handleLogout()} type="button" className="btn btn-secondary">{t("header.logout")}</button>
                </Link>
                {/* <div className="col align-items-end float-end">
                  <button onClick={() => handleLogout()} type="button" className="btn btn-secondary">{t("header.logout")}</button>
                </div> */}

              </div>
            </div>

            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                {user ? <div className="d-flex align-items-center">
                  {/* <Avatar sx={{ bgcolor: 'white', color: deepPurple[500] }}>{user.substring(0, 1).toUpperCase()}</Avatar>
                  <Link to="/options" style={{ color: 'white', textDecoration: 'none' }} className="ps-2">{user}</Link> */}
                  <Link to="/options" style={{ color: 'white', textDecoration: 'none' }} className="ps-2">
                    <Avatar sx={{ bgcolor: 'white', color: deepPurple[500] }}>{user.login.substring(0, 1).toUpperCase()}</Avatar>
                  </Link>
                </div> : ''}
              </li>
            </ul>
            {/* <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link" href="#">Right</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
            </ul>
        </div> */}
          </> : ''}
        </div>
      </nav>
    </>
  )
};

export default Header;